/**
 * Harita SVG ilçe `g[id]` (ör. 58-gürün, 34-bakırköy) ile API’den gelen ilçe listesini eşleştirir.
 * `GET /api/locations/cities/:cityId/districts` → `{ id, adi, cityId }`
 */

/**
 * Türkçe duyarsız karşılaştırma anahtarı (küçük harf + aksansız benzeri).
 * @param {string} s
 * @returns {string}
 */
export function normalizeDistrictMatchKey(s) {
  if (!s || typeof s !== 'string') return '';
  let t = s.trim().toLocaleLowerCase('tr-TR');
  t = t
    .replace(/ı/g, 'i')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c');
  t = t.replace(/[^a-z0-9]+/g, '');
  return t;
}

/**
 * SVG'deki id slug'ı ile DB adı arasında bilinen farklar (normalize sonrası eşleşmeyen edge case'ler).
 * Anahtar: `${cityId}|${slugKey}` veya `${cityId}|${titleKey}` → hedef normalize anahtar (DB adından türetilmiş).
 */
const MANUAL_ALIAS_TARGETS = {
  // örnek: '34|buyukcekmece': 'buyukcekmececekmec' yok — gerekirse ekle
};

/**
 * @param {SVGGElement | Element | null} svgGroup — `#features > g[id]`
 * @param {number} cityId — plaka 1–81
 * @param {Array<{ id?: number, _id?: number, adi?: string, ad?: string, name?: string, cityId?: number }>} ilceler
 * @returns {number | null} districts._id
 */
export function svgDistrictGroupToDbDistrictId(svgGroup, cityId, ilceler) {
  if (!svgGroup || !Number.isFinite(cityId) || !Array.isArray(ilceler)) return null;

  const fullId = svgGroup.getAttribute('id') || '';
  const title = (svgGroup.getAttribute('title') || '').trim();
  const parts = fullId.split('-');
  if (parts.length < 2) return null;

  const plateFromId = parseInt(parts[0], 10);
  if (Number.isFinite(plateFromId) && plateFromId !== cityId) return null;

  const slugRest = parts.slice(1).join('-');
  const slugKey = normalizeDistrictMatchKey(slugRest.replace(/-/g, ' '));
  const titleKey = normalizeDistrictMatchKey(title);

  const manual1 = MANUAL_ALIAS_TARGETS[`${cityId}|${slugKey}`];
  const manual2 = MANUAL_ALIAS_TARGETS[`${cityId}|${titleKey}`];

  const inCity = ilceler.filter((x) => Number(x.cityId) === Number(cityId));

  const tryMatch = (key) => {
    if (!inCity.length || !key) return null;
    for (const row of inCity) {
      const name = String(row.adi || row.ad || row.name || '').trim();
      if (!name) continue;
      const nk = normalizeDistrictMatchKey(name);
      if (nk === key) return Number(row.id ?? row._id);
    }
    return null;
  };

  let hit = tryMatch(manual1) || tryMatch(manual2);
  if (hit != null) return hit;

  hit = tryMatch(titleKey);
  if (hit != null) return hit;

  hit = tryMatch(slugKey);
  return hit != null ? hit : null;
}
